module.exports = __webpack_public_path__ + "static/media/falling_asleep.dc28c563.png";